import {AnyFn} from '../../types/common/functions/AnyFn';
import {cached} from './cached';
import {asString} from '../converters/asString';

export function once<T extends AnyFn>(fn: T): typeof fn {
    return cached<T>(fn, {
        keyFn: (prop) => Symbol.for(`once(${asString(prop)}).ONCE`)
    });
}
